module.exports = __webpack_public_path__ + "assets/img/title-ac0f5855.png";